import { useUiStore } from "@/application/stores/uiStore";
import { Button } from "@/presentation/components/Button";
import { Modal } from "@/presentation/components/overlay/Modal";
import "./MobileGuideOverlay.css";

const TITLE_ID = "mobile-guide-overlay-title";

/**
 * 携帯案内 / 画面が狭い案内（O-3。ui-design.md §7.8・§4.1）。
 * 表示条件（`useIsMobileOrNarrow`）の判定は呼び出し側（`App.tsx`）が持ち、
 * このコンポーネントは「既読か」（`mobileGuideAcknowledged`）だけを見て開閉する。
 * 閉じれば話・免状帳は読める。稽古への導線（S-1のCTA等）は各画面が
 * `useIsMobileOrNarrow()`を直接見て非表示にする（無効化ではなく非表示 — F-010）。
 */
export function MobileGuideOverlay() {
  const acknowledged = useUiStore((state) => state.mobileGuideAcknowledged);
  const setAcknowledged = useUiStore((state) => state.setMobileGuideAcknowledged);

  function acknowledge() {
    setAcknowledged(true);
  }

  return (
    <Modal open={!acknowledged} onClose={acknowledge} titleId={TITLE_ID}>
      <h2 id={TITLE_ID} className="mobile-guide-overlay__title">
        vim道場はキーボードでの稽古を前提にしています
      </h2>
      <p className="mobile-guide-overlay__body">
        タップだけでは打鍵の稽古はできません。閉じれば、話と免状帳は読めます。
      </p>
      <Button variant="primary" onClick={acknowledge}>
        ストーリーと免状帳を見る
      </Button>
    </Modal>
  );
}
